<template>
    <div>
        <Card>
            <p slot="title">{{t.routerName}}</p>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { edit, getConfigInfo, getConfigList } from '@/api/config';

export default {
    name: 'sys_manage_config_list',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderType = (h, params) => {
            const row = params.row;
            const color = row.type === '0' ? 'success' : 'error';
            const text = row.type === '0' ? t.table.typeImage : t.table.typeContent;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderAction = (h, params) => {
            const row = params.row;
            return h(
                'i-button',
                {
                    props: {
                        type: 'primary',
                        size: 'small',
                        to: './edit/' + row.id,
                    },
                },
                msgUtil.message.action.show
            );
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                id: '',
                type: '',
                name: '',
                key1: '',
                value1: '',
                key2: '',
                value2: '',
                key3: '',
                value3: '',
                key4: '',
                value4: '',
                key5: '',
                value5: '',
                key6: '',
                value6: '',
                key7: '',
                value7: '',
                value8: '',
                value9: '',
                value10: '',
                current: 1,
                size: 10,
            },
            data: [],
            total: 0,
            columns: [
                { title: t.table.id, key: 'id', align: 'center', width: 170 },
                { title: t.table.typeName, key: 'type', align: 'center', width: 90, render: renderType },
                { title: t.table.name, key: 'name', align: 'center', width: 120, tooltip: true },
                { title: t.table.key1, key: 'key1', align: 'center', width: 120, tooltip: true },
                { title: t.table.value1, key: 'value1', align: 'center', width: 120, tooltip: true },
                { title: t.table.key2, key: 'key2', align: 'center', width: 120, tooltip: true },
                { title: t.table.value2, key: 'value2', align: 'center', width: 120, tooltip: true },
                { title: t.table.key3, key: 'key3', align: 'center', width: 120, tooltip: true },
                { title: t.table.value3, key: 'value3', align: 'center', width: 120, tooltip: true },
                { title: t.table.key4, key: 'key4', align: 'center', width: 120, tooltip: true },
                { title: t.table.value4, key: 'value4', align: 'center', width: 120, tooltip: true },
                { title: t.table.key5, key: 'key5', align: 'center', width: 120, tooltip: true },
                { title: t.table.value5, key: 'value5', align: 'center', width: 120, tooltip: true },
                { title: t.table.key6, key: 'key6', align: 'center', width: 120, tooltip: true },
                { title: t.table.value6, key: 'value6', align: 'center', width: 120, tooltip: true },
                { title: t.table.key7, key: 'key7', align: 'center', width: 120, tooltip: true },
                { title: t.table.value7, key: 'value7', align: 'center', width: 120, tooltip: true },
                { title: t.table.key8, key: 'key8', align: 'center', width: 120, tooltip: true },
                { title: t.table.value8, key: 'value8', align: 'center', width: 120, tooltip: true },
                { title: t.table.key9, key: 'key9', align: 'center', width: 120, tooltip: true },
                { title: t.table.value9, key: 'value9', align: 'center', width: 120, tooltip: true },
                { title: t.table.key10, key: 'key10', align: 'center', width: 130, tooltip: true },
                { title: t.table.value10, key: 'value10', align: 'center', width: 130, tooltip: true },
                { title: ' ', align: 'center' },
                {
                    title: msgUtil.message.action.name,
                    key: 'operation',
                    align: 'center',
                    width: 90,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    methods: {
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            //console.log(this.formItem);
            const result = await getConfigList(this.formItem);
            //console.log(result);
            if (result) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },

        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
